import { appConfig, DEVELOPMENT_MODE_ENV } from '../constants';
import { rootReducer } from './reducers/rootReducer';
import {
  applyMiddleware,
  compose,
  createStore,
  Middleware,
  Store,
} from 'redux';
import customMiddleware from './custom-middleware';

const developmentMode = appConfig.env.NODE_ENV === DEVELOPMENT_MODE_ENV;
const composeEnhancers =
  (developmentMode && window && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
  compose;

function configureStore(): Store {
  // compose enhancers
  const enhancer = composeEnhancers(
    applyMiddleware(customMiddleware as Middleware),
  );

  // create store
  const store = createStore(rootReducer, enhancer);

  if (developmentMode && window.Cypress) {
    window.__CYPRESS_REDUX_STORE__ = store;
  }

  return store;
}

const getStore = (() => {
  let store: Store;

  return () => {
    if (!store) {
      store = configureStore();
    }

    return store;
  };
})();

export default getStore;
